import { render, staticRenderFns } from "./BlogPreview.vue?vue&type=template&id=0724a817&"
import script from "./BlogPreview.vue?vue&type=script&lang=js&"
export * from "./BlogPreview.vue?vue&type=script&lang=js&"
import style0 from "./BlogPreview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports